import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import { storeToRefs } from 'pinia'

import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

export function useCurrentHighlightedItem(
  highlightedId: () => number | undefined,
  highlightedType: () => string | undefined
): {
  currentId: ComputedRef<number | undefined>
  currentItemClass: ComputedRef<string | undefined>
} {
  const { currentReviewItem } = storeToRefs(useWorfklowReviewItems())

  const currentId = computed(
    () => highlightedId() ?? currentReviewItem.value?.id
  )
  const currentItemClass = computed(
    () => highlightedType() ?? currentReviewItem.value?.itemClass
  )

  return { currentId, currentItemClass }
}
